import React from "react";
import { be } from 'date-fns/locale';
import { getCountryCode, getFlagUrl, renderNull } from '../../SysGuard/Dashboard/ContentPages/SysGuardColumnConfig';
import { notification } from 'antd';
import Popover from "@material-ui/core/Popover";

export const GET_DATAGUARD_HEADER_DATA = "GET_DATAGUARD_HEADER_DATA";
export const SET_DATAGUARD_HEADER_DATA = "SET_DATAGUARD_HEADER_DATA";
export const GET_DATAGUARD_HEATMAP_DATA = "GET_DATAGUARD_HEATMAP_DATA";
export const SET_DATAGUARD_HEATMAP_DATA = "SET_DATAGUARD_HEATMAP_DATA";
export const GET_DATAGUARD_ROLES_DATA = "GET_DATAGUARD_ROLES_DATA";
export const SET_DATAGUARD_ROLES_DATA = "SET_DATAGUARD_ROLES_DATA";
export const GET_DATAGUARD_BEHAVIOR_DATA = "GET_DATAGUARD_BEHAVIOR_DATA";
export const SET_DATAGUARD_BEHAVIOR_DATA = "SET_DATAGUARD_BEHAVIOR_DATA";
export const SET_DATAGUARD_FROM_TIME_STAMP = "SET_DATAGUARD_FROM_TIME_STAMP";
export const SET_DATAGUARD_INCOGNITO = "SET_DATAGUARD_INCOGNITO";
export const SET_DATAGUARD_TO_TIME_STAMP = "SET_DATAGUARD_TO_TIME_STAMP";
export const domain_vizr = process.env.REACT_APP_DOMAIN_VIZR;
export const GET_USER_ROLE_URL = domain_vizr + "/dataguard/userRole/summary";
export const GET_BEHAVIOR_MODEL_URL =
  domain_vizr + "/dataguard/behaviorModel/summary";
export const GET_LOCATION_SUMMARY = "GET_LOCATION_SUMMARY";
export const GET_KEY_DOC_OWNER_DATA = "GET_KEY_DOC_OWNER_DATA";
export const SET_KEY_DOC_OWNER_DATA = "SET_KEY_DOC_OWNER_DATA";
export const KEY_DOC_OWNER_API =
  domain_vizr + `/dataguard/publicDataAssets/topPdaAccessUsers`;
export const LOCATION_SUMMARY_API = domain_vizr + `/dataguard/location/summary`;
export const SET_LOCATION_SUMMARY = "SET_LOCATION_SUMMARY";
export const notificationToggle = (state) => {
  return `${domain_vizr}/dataguard/alerts/notification/${state}`
}
export const DATA_GUARD_NOTIFICATION_TOGGLE = "DATA_GUARD_NOTIFICATION_TOGGLE";
export const ACTION_NOT_NEEDED = ["publicdata", "locations"];

export const renderFlag = (country, tableColumn = false) => {
  const code = getCountryCode(country);
  let flagUrl = "/sysGuardIcons/unknownFlag.svg";
  if (code && code !== "Unknown" && code !== "Not Found") {
    flagUrl = getFlagUrl(code);
  }
  if (tableColumn) {
    return <div className="country-badge" title={country.name}>
      <img className='country-flag' alt={country} src={flagUrl} title={country.name} />
      <div className="country-code" title={country.name}>{code || "N/A"}</div>
    </div>;
  } else {
    return (
      <img title={country} className="country-flag" alt={country} src={flagUrl} />
    );
  }
};

// Internal component with self-managed popover state
const CountryNamesWithPopover = ({ countryNamesValue, minCountries = 5, containerClassName = "country-names-container" }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popoverData, setPopoverData] = React.useState([]);

  if (!countryNamesValue) return renderNull();

  const open = Boolean(anchorEl);

  let countryNames;
  if (Array.isArray(countryNamesValue)) {
    countryNames = countryNamesValue.map(name => typeof name === 'string' ? name.trim() : name);
  } else if (typeof countryNamesValue === 'string') {
    countryNames = countryNamesValue.split(",").map((name) => name.trim());
  } else {
    return renderNull();
  }

  const shortCountryNames = countryNames.slice(0, minCountries);
  const remainingCountryNames = countryNames.slice(minCountries);
  const remainingCount = remainingCountryNames.length;

  const getCountryData = (names) =>
    names.map((name) => {
      const code = getCountryCode(name);
      const flagUrl = code && code !== "Unknown" ? getFlagUrl(code) : "/sysGuardIcons/unknownFlag.svg";
      return { name, code, flagUrl };
    });

  const shortCountryData = getCountryData(shortCountryNames);
  const remainingCountryData = getCountryData(remainingCountryNames);

  const handlePopoverToggle = (event) => {
    event.stopPropagation();
    if (anchorEl) {
      setAnchorEl(null);
      setPopoverData([]);
    } else {
      setAnchorEl(event.currentTarget);
      setPopoverData(remainingCountryData);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverData([]);
  };

  return (
    <div className={containerClassName}>
      {shortCountryData.map((country, index) => (
        <div key={index} className="country-badge" title={country.name}>
          <img
            src={country.flagUrl}
            alt={country.name}
            className="country-flag"
            title={country.name}
          />
          <div className="country-code" title={country.name}>{country.code || "N/A"}</div>
        </div>
      ))}

      {remainingCount > 0 && (
        <>
          <div className="remaining-image-count-dataguard-container">
            <div
              className="circle sysguard"
              onClick={handlePopoverToggle}
            >
              <span className="circleText sysguard">{`+${remainingCount}`}</span>
            </div>
          </div>

          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <div className="popover-country-list">
              {popoverData.map((country, index) => (
                <div key={index} className="country-badge" title={country.name}>
                  <img
                    src={country.flagUrl}
                    alt={country.name}
                    className="country-flag"
                  />
                  <div className="country-code">{country.code || "N/A"}</div>
                </div>
              ))}
            </div>
          </Popover>
        </>
      )}
    </div>
  );
};

// Generic function for rendering country names with popover (like SysGuard)
// Now with internal state management - no external state required!
export const renderCountryNamesWithPopover = (countryNamesValue, minCountries = 5, containerClassName = "country-names-container") => {
  return (
    <CountryNamesWithPopover 
      countryNamesValue={countryNamesValue}
      minCountries={minCountries}
      containerClassName={containerClassName}
    />
  );
};

export const getDetailsURL = (url) => {
  return domain_vizr + url;
};

export const locationFilterListAPI = (fromTimeStamp, toTimeStamp) => {
  return `${domain_vizr}/dataguard/locations/distinct?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`;
}

export const formatNumber = (num) => {
  if (num === null || num === undefined) return "0";
  if (typeof num !== "number") {
    num = parseInt(num);
    if (isNaN(num)) return "0";
  }
  let formatter = Intl.NumberFormat("en", { notation: "compact" });
  return formatter.format(num);
};

const locationTransformation = (
  data,
  countryTotalActivities = 0,
  overallTotalActivities = 0,
  countryObj = {}
) => {
  if (!data) return countryObj;

  countryObj.location = data.country;
  countryObj.noOfUsers = countryObj.noOfUsers || [];
  countryObj.anomaly = countryObj.anomaly || [];
  countryObj.activities = countryObj.activities || [];
  countryObj.uniqueDataAssets = countryObj.uniqueDataAssets || [];

  // Users
  countryObj.usersAccumulated = countryObj.usersAccumulated || {};
  (data.usersCountPerDs || []).forEach((dsData) => {
    countryObj.usersAccumulated[dsData.dataSourceId] = {
      count:
        (countryObj.usersAccumulated[dsData.dataSourceId]?.count || 0) +
        dsData.usersCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  countryObj.noOfUsers = [
    ...countryObj.noOfUsers,
    ...(data.usersCountPerDs || []),
  ];

  // Anomalies
  countryObj.anomalyAccumulated = countryObj.anomalyAccumulated || {};
  (data.noOfAnomaliesPerDs || []).forEach((dsData) => {
    countryObj.anomalyAccumulated[dsData.dataSourceId] = {
      count:
        (countryObj.anomalyAccumulated[dsData.dataSourceId]?.count || 0) +
        dsData.totalAnomaliesCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  countryObj.anomaly = [
    ...countryObj.anomaly,
    ...(data.noOfAnomaliesPerDs || []),
  ];

  // Activities
  countryObj.activitiesAccumulated = countryObj.activitiesAccumulated || {};
  (data.noOfActivitiesPerDs || []).forEach((dsData) => {
    countryObj.activitiesAccumulated[dsData.dataSourceId] = {
      count:
        (countryObj.activitiesAccumulated[dsData.dataSourceId]?.count || 0) +
        dsData.activitiesCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
      countryTotalActivities: countryTotalActivities,
      overallTotalActivities: overallTotalActivities,
      countryName: data.country,
    };
  });
  countryObj.activities = [
    ...countryObj.activities,
    ...(data.noOfActivitiesPerDs || []),
  ];

  // Unique Data Assets
  countryObj.uniqueDataAssetsAccumulated =
    countryObj.uniqueDataAssetsAccumulated || {};
  (data.uniqueDataAssetsPerDs || []).forEach((dsData) => {
    if (dsData.dataAssetsCount > 0) {
      countryObj.uniqueDataAssetsAccumulated[dsData.dataSourceId] = {
        count:
          (countryObj.uniqueDataAssetsAccumulated[dsData.dataSourceId]?.count ||
            0) + dsData.dataAssetsCount,
        dataSourceName: dsData.dataSourceName,
        dataSourceType: dsData.dataSourceType,
      };
    }
  });
  countryObj.uniqueDataAssets = [
    ...countryObj.uniqueDataAssets,
    ...(data.uniqueDataAssetsPerDs || []),
  ];

  return countryObj;
};

const roleTransformation = (data, roleObj = {}) => {
  if (!data) return roleObj;

  roleObj.roleName = data.name;
  roleObj.users = roleObj.users || [];
  roleObj.anomalies = roleObj.anomalies || [];
  roleObj.activeUsers = roleObj.activeUsers || [];
  roleObj.countries = roleObj.countries || [];

  // Users count per data source
  roleObj.usersAccumulated = roleObj.usersAccumulated || {};
  (data.usersCountPerDs || []).forEach((dsData) => {
    roleObj.usersAccumulated[dsData.dataSourceId] = {
      count:
        (roleObj.usersAccumulated[dsData.dataSourceId]?.usersCount || 0) +
        dsData.usersCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  roleObj.users = [...roleObj.users, ...(data.usersCountPerDs || [])];

  // Anomalies count per data source
  roleObj.anomaliesAccumulated = roleObj.anomaliesAccumulated || {};
  (data.noOfAnomaliesPerDs || []).forEach((dsData) => {
    roleObj.anomaliesAccumulated[dsData.dataSourceId] = {
      count:
        (roleObj.anomalyAccumulated?.[dsData.dataSourceId]?.anomaliesCount ||
          0) + dsData.totalAnomaliesCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  roleObj.anomalies = [
    ...roleObj.anomalies,
    ...(data.noOfAnomaliesPerDs || []),
  ];

  // Active users per data source
  roleObj.activeUsersAccumulated = roleObj.activeUsersAccumulated || {};
  (data.activeUsersPerDs || []).forEach((dsData) => {
    roleObj.activeUsersAccumulated[dsData.dataSourceId] = {
      count:
        (roleObj.activeUsersAccumulated[dsData.dataSourceId]
          ?.activeUsersCount || 0) + dsData.activeUsersCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  roleObj.activeUsers = [
    ...roleObj.activeUsers,
    ...(data.activeUsersPerDs || []),
  ];

  roleObj.locationsAccumulated = roleObj.locationsAccumulated || {};
  const dsArray = data.locationsPerDs || [];

  dsArray.forEach((dsData) => {
    const countries = (dsData.locations || [])
      .map((loc) => loc?.country?.trim())
      .filter(Boolean);

    const uniqueCountries = [...new Set(countries)];

    // Save per data source
    roleObj.locationsAccumulated[dsData.dataSourceId] = {
      locations: uniqueCountries,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });

  // Maintain countries array like activeUsers
  roleObj.countries = [
    ...roleObj.countries,
    ...dsArray.map((dsData) => ({
      dataSourceId: dsData.dataSourceId,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
      locations: [
        ...new Set(
          (dsData.locations || [])
            .map((loc) => loc?.country?.trim())
            .filter(Boolean)
        ),
      ],
    })),
  ];


  roleObj.locations = data.locations || [];
  // Total percentage of users
  roleObj.percentageOfTotalUsers =
    data.percentageOfTotalUsers || roleObj.percentageOfTotalUsers;

  return roleObj;
};

const publicDataTransformation = (data, publicObj = {}) => {
  if (!data) return publicObj;

  publicObj.ownerId = data.ownerId;
  publicObj.ownerName = data.ownerName;
  publicObj.action = publicObj.action || {};
  publicObj.action.ownerId = data.ownerId;
  publicObj.action.userName = data.ownerName;

  // Assets per datasource
  publicObj.assetCountPerDs = publicObj.assetCountPerDs || [];
  publicObj.assetsAccumulated = publicObj.assetsAccumulated || {};
  (data.assetCountPerDs || []).forEach((dsData) => {
    publicObj.assetsAccumulated[dsData.dataSourceId] = {
      count:
        (publicObj.assetsAccumulated[dsData.dataSourceId]?.count || 0) +
        dsData.dataAssetsCount,
      totalAssetsCount:
        (publicObj.assetsAccumulated[dsData.dataSourceId]?.totalAssetsCount || 0) +
        dsData.totalAssetsCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  publicObj.assetCountPerDs = [
    ...publicObj.assetCountPerDs,
    ...(data.assetCountPerDs || []),
  ];

  // Public asset access activities per datasource
  publicObj.publicAssetAccessCountPerDs =
    publicObj.publicAssetAccessCountPerDs || [];
  publicObj.activitiesAccumulated = publicObj.activitiesAccumulated || {};
  (data.publicAssetAccessCountPerDs || []).forEach((dsData) => {
    publicObj.activitiesAccumulated[dsData.dataSourceId] = {
      count:
        (publicObj.activitiesAccumulated[dsData.dataSourceId]?.count || 0) +
        dsData.activitiesCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  publicObj.publicAssetAccessCountPerDs = [
    ...publicObj.publicAssetAccessCountPerDs,
    ...(data.publicAssetAccessCountPerDs || []),
  ];

  // Combine unique dataSourceIds from both assetCountPerDs and publicAssetAccessCountPerDs
  const assetDsIds = (publicObj.assetCountPerDs || []).map(ds => ds.dataSourceId);
  const publicAccessDsIds = (publicObj.publicAssetAccessCountPerDs || []).map(ds => ds.dataSourceId);
  const uniqueDsIds = [...new Set([...assetDsIds, ...publicAccessDsIds])];

  publicObj.action.dataSourceId = uniqueDsIds;

  // Locations
  publicObj.locations = [
    ...(publicObj.locations || []),
    ...(data.locations || []),
  ];

  return publicObj;
};


const behaviourTransformation = (data, behaviourObj = {}) => {
  if (!data) return behaviourObj;

  behaviourObj.policyName = data.name;
  behaviourObj.policyId = data.policyId;


  // Users per datasource
  behaviourObj.users = behaviourObj.users || [];
  behaviourObj.usersAccumulated = behaviourObj.usersAccumulated || {};
  (data.users || []).forEach((dsData) => {
    behaviourObj.usersAccumulated[dsData.dataSourceId] = {
      count:
        (behaviourObj.usersAccumulated[dsData.dataSourceId]?.count || 0) +
        dsData.usersCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  behaviourObj.users = [...behaviourObj.users, ...(data.users || [])];

  // Total anomalies by datasource
  behaviourObj.totalAnomaliesByDs = behaviourObj.totalAnomaliesByDs || [];
  behaviourObj.totalAnomaliesAccumulated =
    behaviourObj.totalAnomaliesAccumulated || {};
  (data.totalAnomaliesByDs || []).forEach((dsData) => {
    behaviourObj.totalAnomaliesAccumulated[dsData.dataSourceId] = {
      count:
        (behaviourObj.totalAnomaliesAccumulated[dsData.dataSourceId]?.count ||
          0) + dsData.totalAnomaliesCount,
      high:
        (behaviourObj.totalAnomaliesAccumulated[dsData.dataSourceId]?.high ||
          0) + dsData.high,
      medium:
        (behaviourObj.totalAnomaliesAccumulated[dsData.dataSourceId]?.medium ||
          0) + dsData.medium,
      low:
        (behaviourObj.totalAnomaliesAccumulated[dsData.dataSourceId]?.low ||
          0) + dsData.low,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  behaviourObj.totalAnomaliesByDs = [
    ...behaviourObj.totalAnomaliesByDs,
    ...(data.totalAnomaliesByDs || []),
  ];

  // Open anomalies by datasource
  behaviourObj.openAnomalies = behaviourObj.openAnomalies || [];
  behaviourObj.openAnomaliesAccumulated =
    behaviourObj.openAnomaliesAccumulated || {};
  (data.openAnomalies || []).forEach((dsData) => {
    behaviourObj.openAnomaliesAccumulated[dsData.dataSourceId] = {
      count:
        (behaviourObj.openAnomaliesAccumulated[dsData.dataSourceId]?.count ||
          0) + dsData.anomaliesCount,
      dataSourceName: dsData.dataSourceName,
      dataSourceType: dsData.dataSourceType,
    };
  });
  behaviourObj.openAnomalies = [
    ...behaviourObj.openAnomalies,
    ...(data.openAnomalies || []),
  ];

  // Severity counts (overall totals)
  behaviourObj.severity = behaviourObj.severity || {
    high: 0,
    medium: 0,
    low: 0,
  };
  behaviourObj.severity.high += data.high || 0;
  behaviourObj.severity.medium += data.medium || 0;
  behaviourObj.severity.low += data.low || 0;
  behaviourObj.action = behaviourObj.action || {
    notification: false,
    policyId: null,
    policyName: data.name,
    severity: {...behaviourObj.severity}
  };
  behaviourObj.action.notification = data.notificationEnabled || false;
  behaviourObj.action.policyId = data.policyId || behaviourObj.action.policyId;

  return behaviourObj;
};


export const transformToTableData = (data, pageType) => {
  if (!data) return [];

  switch (pageType) {
    case "locations":
      const countryGroups = {};
      const totalActivities = {};
      let overallTotalActivities = 0;
      for (let i = 0; i < data.length; i++) {
        const country = data[i].country;
        const countrywiseActivities = data[i]?.noOfActivitiesPerDs?.reduce(
          (sum, v) => sum + v.activitiesCount,
          0
        );
        totalActivities[country] =
          (totalActivities[country] || 0) + countrywiseActivities;
        overallTotalActivities += countrywiseActivities;
      }
      for (let i = 0; i < data.length; i++) {
        if (!data[i].country) continue;
        const cityData = data[i];
        const country = cityData.country;
        if (countryGroups[country]) {
          countryGroups[country] = locationTransformation(
            cityData,
            totalActivities[country],
            overallTotalActivities,
            countryGroups[country]
          );
        } else {
          countryGroups[country] = locationTransformation(
            cityData,
            totalActivities[country],
            overallTotalActivities
          );
        }
      }
      return Object.values(countryGroups);

    case "roles":
      const roleGroups = {};
      for (let i = 0; i < data.length; i++) {
        const roleData = data[i];
        const roleName = roleData.name;

        if (roleGroups[roleName]) {
          roleGroups[roleName] = roleTransformation(
            roleData,
            roleGroups[roleName]
          );
        } else {
          roleGroups[roleName] = roleTransformation(roleData);
        }
      }
      return Object.values(roleGroups);

    case "publicdata":
      const publicGroups = {};
      for (let i = 0; i < data.length; i++) {
        const publicData = data[i];
        const ownerId = publicData.ownerId; // grouping by ownerId

        if (publicGroups[ownerId]) {
          publicGroups[ownerId] = publicDataTransformation(
            publicData,
            publicGroups[ownerId]
          );
        } else {
          publicGroups[ownerId] = publicDataTransformation(publicData);
        }
      }
      return Object.values(publicGroups);

    case "behaviormodels":
      const behaviourGroups = {};
      for (let i = 0; i < data.length; i++) {
        const behaviourData = data[i];
        const policyName = behaviourData.name;

        if (behaviourGroups[policyName]) {
          behaviourGroups[policyName] = behaviourTransformation(
            behaviourData,
            behaviourGroups[policyName]
          );
        } else {
          behaviourGroups[policyName] = behaviourTransformation(behaviourData);
        }
      }

      // Map the accumulated object into the final format your table expects
      const policiesList = Object.values(behaviourGroups).map((item) => ({
        policyName: item.policyName,
        policyId: item.policyId,
        users: item.usersAccumulated,
        totalAnomaliesByDs: item.totalAnomaliesAccumulated,
        openAnomalies: item.openAnomaliesAccumulated,
        severity: item.severity, // Already accumulated high/medium/low
        action: item.action,
      }));
      return policiesList.sort((a, b) => a.policyName.localeCompare(b.policyName));

    default:
      return [];
  }
};

export const SET_NOTIFICATION_UPDATE_STATUS = "SET_NOTIFICATION_UPDATE_STATUS";
export const SET_DATA_GUARD_ALERT_COMMENT = "SET_DATA_GUARD_ALERT_COMMENT";
export const DISPLAY_DATA_GUARD_ALERT_COMMENT = "DISPLAY_DATA_GUARD_ALERT_COMMENT";
export const SAVE_DATA_GUARD_COMMENT = "SAVE_DATA_GUARD_COMMENT";
export const CREATE_DATA_GUARD_JIRA_INCIDENT = "CREATE_DATA_GUARD_JIRA_INCIDENT";
export const SET_DATA_GUARD_ALERT_STATUS = "SET_DATA_GUARD_ALERT_STATUS";
export const UPDATE_ALERT_STATUS_REQUEST_DATAGUARD = "UPDATE_ALERT_STATUS_REQUEST_DATAGUARD";
export const UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD = "UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD";
export const UPDATE_ALERT_STATUS_FAILED_DATAGUARD = "UPDATE_ALERT_STATUS_FAILED_DATAGUARD";
export const OPEN_DATA_GUARD_SNACKBAR = "OPEN_DATA_GUARD_SNACKBAR";
export const SET_DATA_GUARD_REPORT_INCIDENT_DATA = "SET_DATA_GUARD_REPORT_INCIDENT_DATA";
export const dataGuardReportIncidentFailed = "Failed to Report Incident";
export const DATA_GUARD_REPORT_INCIDENT_SUCCESSFUL = "DATA_GUARD_REPORT_INCIDENT_SUCCESSFUL";
export const DATA_GUARD_REPORT_INCIDENT_FAILED = "DATA_GUARD_REPORT_INCIDENT_FAILED";
export const SET_DATA_GUARD_REPORT_INCIDENT_DETAILS = "SET_DATA_GUARD_REPORT_INCIDENT_DETAILS";
export const reportToJiraDataGuard = (alertId, dataSourceId) => {
  return `${domain_vizr}/jira/SIR/createIncident?alertId=${alertId}&dataSourceId=${dataSourceId}`;
}
export const UPDATE_ALERTS_STATUS_URL = domain_vizr + "/tenant/alerts/status"; //get alerts url
export const revokePublicAccessAPI = (dataSourceId, userEmailId) => `${domain_vizr}/tenant/publicDataAsset/${dataSourceId}/revokeAccess/actorEmail/${userEmailId}`;
export const PUBLIC_ACCESS_REVOKE_USER = "PUBLIC_ACCESS_REVOKE_USER"
export const SET_REVOKE_ACCESS_UPDATE_STATUS = "SET_REVOKE_ACCESS_UPDATE_STATUS";
export const ALERT_ACTION_REQUEST_DATAGUARD = "ALERT_ACTION_REQUEST_DATAGUARD";
export const ALERT_ACTION_SUCCESS_DATAGUARD = "ALERT_ACTION_SUCCESS_DATAGUARD";
export const ALERT_ACTION_FAILED_DATAGUARD = "ALERT_ACTION_FAILED_DATAGUARD";
export const alertActionAPI = (actionType) => `${domain_vizr}/dataguard/alerts/status/${actionType}`;
export const dataGuardFiltersEndPoints = {
  location: `${domain_vizr}/dataguard/locations/distinct`,
  userRoles: `${domain_vizr}/dataguard/userRoles/distinct`,
  policySubType: `${domain_vizr}/dataguard/behaviorModels/policySubtype/distinct`,
  owners: `${domain_vizr}/dataguard/publicDataAssets/owners/distinct`,
};
export const GET_DATA_GUARD_FILTERS_LIST = "GET_DATA_GUARD_FILTERS_LIST";
export const SET_DATA_GUARD_LOCATION_FILTERS = "SET_DATA_GUARD_LOCATION_FILTERS";
export const SET_DATA_GUARD_SELECTED_LOCATION_FILTERS = "SET_DATA_GUARD_SELECTED_LOCATION_FILTERS";
export const SET_DATA_GUARD_POLICY_SUBTYPE_FILTERS = "SET_POLICY_SUBTYPE_FILTERS";
export const SET_DATA_GUARD_SELECTED_POLICY_SUBTYPE_FILTERS = "SET_DATA_GUARD_SELECTED_POLICY_SUBTYPE_FILTERS";
export const SET_DATA_GUARD_SEVERITY_FILTERS = "SET_DATA_GUARD_SEVERITY_FILTERS";
export const SET_DATA_GUARD_SELECTED_SEVERITY_FILTERS = "SET_DATA_GUARD_SELECTED_SEVERITY_FILTERS";
export const SET_DATA_GUARD_USER_ROLES_FILTERS = "SET_DATA_GUARD_USER_ROLES_FILTERS";
export const SET_DATA_GUARD_SELECTED_USER_ROLES_FILTERS = "SET_DATA_GUARD_SELECTED_USER_ROLES_FILTERS";
export const SET_DATA_GUARD_OWNERS_FILTERS = "SET_DATA_GUARD_OWNERS_FILTERS";
export const SET_DATA_GUARD_SELECTED_OWNERS_FILTERS = "SET_DATA_GUARD_SELECTED_OWNERS_FILTERS";
export const CLEAR_DATA_GUARD_FILTERS = "CLEAR_DATA_GUARD_FILTERS"; 

export const StatusMap = {
  UNRESOLVED: "Unresolved",
  RESOLVED: "Resolved",
  FALSE_POSITIVE: "False Positive",
}
